import type { ServicesPageQuery } from 'src/types';
import type { TranslateFunc } from '../translate';
import type { ClientMarket } from '@prisjakt/web-app-config/types/client-market';

const servicesMetaTags = (
  data: ServicesPageQuery,
  { market, t }: { market: ClientMarket; t: TranslateFunc }
) => {
  const tags = {
    title: t('meta', 'landing.title'),
    description: t('meta', 'landing.description'),
    canonical: market.domain,
    openGraph: [],
  };

  if (!data) {
    return tags;
  }

  const { categoryTree } = data;

  return {
    ...tags,
    openGraph: [
      {
        key: 'title',
        content: t('meta', 'company.name'),
      },
      { key: 'type', content: 'website' },
      categoryTree?.[0] && {
        key: 'image',
        content: categoryTree[0].logo,
      },
      { key: 'url', content: market.domain },
    ].filter(Boolean),
  };
};

export default servicesMetaTags;
